import React from "react";
import { Route, BrowserRouter, Switch, withRouter } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import "./../scss/admin/notifications.scss";
import VoucherPayment from "./Payment";
import PaymentStatus from "./Payment/PaymentStatus";
import PaypalPaymentStatus from "./Payment/PaypalPaymentStatus";
import PaymentCallback from "./Payment/PaymentCallback";
import PaymentCallbackReserveFund from "./Payment/PaymentCallbackReserveFund";
import PaypalPaymentCallback from "./Payment/PaypalPaymentCallback";
import PaypalPayment from "./Payment/paypalPayment";
import ProfileService from "../services/profileService";
import Header from "../components/Header/index.js";
import Footer from "../components/Footer";
import MFAModal from "./MFA/MFAModal.js";
import Intercom, { update } from "@intercom/messenger-js-sdk";

// import Routes from "../components/Routes/Routes";
import {
  makeRequestAuth,
  setPlatfmCookie,
  getCookieToken,
  STORAGE,
} from "../utils/globals";
// import 	AdminSettings 	from "./components/adminSettings";
// import 	Dashboard 			from "./Dashboard";
import PageLoader from "../components/PageLoader";
import config from "config";
import route from "../config/routesConfig";
import PrivateRoutes from "../components/Routes/PrivateRoutes";
import PrivateRoute from "../components/Routes/PrivateRoute";
import { MODULE_ACL_SWITCH } from "../constants/RouteConstant";

import { LOGIN_COOKIE_NAME } from "../constants/AppConstant";

import { ErrorBoundary } from "react-error-boundary";
import ExceptionHandler from "../components/ExceptionHandler";
import profileService from "../services/profileService";
import EmailPreviewScreen from "./EmailPreviewScreen/emailPreviewIndex.js";
import XoxolinkEmailPreview from "./EmailPreviewScreen/xoxolinkEmailPreview.js";
import { ACL_MODULE_MAPPING } from "./../constants/RouteConstant";
import SignUp from "./DiyLogin";
import AccessDenied from "../components/AccessDenied";
import CampaignLandingPreview from "./Campaign/LandingPage/LandingPreview/index";
import {
  empulsPaymentHistory,
  plumPaymentHistoryReq,
  plumProPaymentHistory,
  voucherRechargeHistory,
} from "./../utils/reports/";
import RazorpayPaymentCallback from "./Payment/RazorpayPaymentCallback";
import PayoneerPaymentCallback from "./Payment/PayoneerPaymentCallback";
import RazorpayPaymentStatus from "./Payment/RazorpayPaymentStatus";
import PrimerPaymentCallback from "./Payment/PrimerPaymentCallback";
import StripePaymentCallback from "./Payment/StripePaymentCallback";
import StripePaymentStatus from "./Payment/StripePaymentStatus";
import { app_path } from "config";
import PayoneerPaymentStatus from "./Payment/PayoneerPaymentStatus";
import MobileLanding from "../components/MobileLanding";
import posthog from "posthog-js";

const backDisabledRoutes = [
  "razorpay-payment-status",
  "primer-payment-status",
  "payoneer-payment-status",
];

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dasboard_load: false,
      hasError: false,
      loader: false,
      getMenuLoader: false,
      moduleAclLoader: false,
      module_acl_switch: false,
      showPageLoader: true,
      progress: 10,
      isMobileDevice: false,
      getAddressDetailsLoader: false,
      use_case: "",
      isFirstRewardSent: false,
      fetchAdminDetailsLoader: false,
    };
    this.currentPathname = null;
    this.currentSearch = null;
    this.setDefaultSite = this.setDefaultSite.bind(this);
    this.timer = null;
  }

  checkIfNewPathInBackDisabledRoutes = (pathname) => {
    const indexNo = backDisabledRoutes.findIndex((item) =>
      pathname.includes(item)
    );
    return indexNo > -1;
  };
  updateWindowDimensions = () => {
    this.setState({
      isMobileDevice:
        window.innerWidth < 1024 &&
        window.innerHeight < 2340 &&
        !window.location?.pathname?.includes("signup"),
    });
  };
  componentDidMount() {
    const { history } = this.props;
    posthog.init(config.posthog_api_key);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    this.timer = setInterval(() => {
      this.setState(({ progress }) => {
        return progress >= 90 ? { progress: 90 } : { progress: progress + 10 };
      });
    }, 200);
    setPlatfmCookie("pltfm", 4);
    //IF ACL ON
    const url = config.storeFrontUrl.replace(/\/$/g, "");
    if (Number(this.doLoginCheck()) == 1) {
      this.setState({ showPageLoader: false });
      if (history.location.pathname == `/${config.app_path}/signup`) {
        history.push(`/${config.app_path}/xoxo-points`);
      }
      // this.getUserModuleAccess()
      this.getAddressDetails();
      this.fetchAdminDetails();
      this.plumProPoints();
      this.getUserBalance();
      this.getClientId();
      this.fetchMFADetails();
      this.getMenu();
      // this.setDefaultSite();
      this.getActiveIntegration();
      // this.getMenuforAwardAccess();
      this.getPlatformSetting();
      //api for active integration list
      this.getAllIntegrations();
      this.getSupport();
      this.getDashboardType();
      setTimeout(() => {
        this.getDatalayerData();
      }, 5000);
    } else {
      if (history.location.pathname !== `/${app_path}/signup`) {
        window.location.href = `${url}/marketplace/login`;
      } else {
        this.setState({ showPageLoader: false });
      }
    }
    history.listen((newLocation, action) => {
      const newPathname = newLocation?.pathname || "";
      if (
        action === "POP" &&
        this.checkIfNewPathInBackDisabledRoutes(newPathname)
      ) {
        history.go(1);
      }
    });
  }

  getDashboardType = () => {
    this.setState({ dasboard_load: true });
    const query = "diy.query.get_activation_steps";
    const request_data = {
      query,
      tag: "diy",
      variables: {},
    };
    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.getActivationSteps &&
          response.data.getActivationSteps.success == 1
        ) {
          this.setState({
            dasboard_load: false,
            use_case: response.data.getActivationSteps.data.usecase,
            isFirstRewardSent:
              response.data.getActivationSteps.data.isFirstRewardSent,
          });
        } else {
          this.setState({ dasboard_load: false });
        }
      }.bind(this)
    );
  };

  fetchAdminDetails = () => {
    this.setState({ fetchAdminDetailsLoader: true });
    const { updateEmployeeDetails } = this.props;

    ProfileService.adminDetails({})
      .then((response) => {
        if (response && response.fetchUserDetails) {
          let userDetails = {
            timeZone: response?.fetchUserDetails?.timeZone || "",
            employee_first_name: response?.fetchUserDetails?.first_name || "",
            employee_last_name: response?.fetchUserDetails?.last_name || "",
            employee_email: response?.fetchUserDetails?.email || "",
            employee_primary_mobile: response?.fetchUserDetails?.contact || "",
            platform: response?.fetchUserDetails?.platform || "",
            domain: response?.fetchUserDetails?.domain || "",
            mobile_verified: response?.fetchUserDetails?.mobile_verified || 0,
            user_creation_date:
              response?.fetchUserDetails?.user_creation_date || "",
          };
          userDetails.employee_full_name = userDetails?.employee_first_name;
          userDetails.employee_full_name += userDetails?.employee_first_name
            ? " " + userDetails?.employee_last_name
            : userDetails.employee_last_name;

          updateEmployeeDetails(userDetails);
          Intercom({
            app_id: config.intercom_workspace_id,
            user_id: response?.fetchUserDetails?.email || "",
            name: response?.fetchUserDetails?.first_name || "" + " " + response?.fetchUserDetails?.last_name || "",
            email: response?.fetchUserDetails?.email || "",
            created_at: new Date(response?.fetchUserDetails?.user_creation_date || "").getTime(),
          });
          // process.env.NODE_ENV === 'production' ? this.pendoInitialize(response.fetchUserDetails, userDetails.employee_full_name) : null
        }
        // if(response && response.fetchAdminDetails && response.fetchAdminDetails.employee_details && response.fetchAdminDetails.employee_details[0]){

        // 	updateEmployeeDetails(response.fetchAdminDetails.employee_details[0])
        // }
        this.setState({ fetchAdminDetailsLoader: false });
      })
      .catch((error) => {
        this.setState({ fetchAdminDetailsLoader: false });
      });
  };

  pendoInitialize = (data, full_name) => {
    // in your authentication promise handler or callback
    pendo.initialize({
      visitor: {
        id: data.gtmUserKey || "", // Required if user is logged in
        email: data.email || "", // Recommended if using Pendo Feedback
        full_name: full_name, // Recommended if using Pendo Feedback
        // role:        , // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },

      account: {
        id: data.gtmCompanyKey || "", // Highly recommended
        name: data.domain || "", // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  };
  getClientId = () => {
    this.setState({ loader: true });
    const {
      updateClientId,
      updateKybStatus,
      updateDistributionType,
      updateAllowedDomains,
      updateCcRechargeAllowed,
      updateAllowOnlineTransfer,
    } = this.props;

    ProfileService.getClientId({})
      .then((response) => {
        if (
          response &&
          response.getClientId &&
          response.getClientId.status == true &&
          response.getClientId.data
        ) {
          // if kyb rejected then logout
          if (response.getClientId.data.kyb_status === 4) {
            makeRequestAuth(
              {},
              function () {
                STORAGE("jose", "", 1);
                STORAGE("login_email", "", 1);
                STORAGE("e_login", "", 1);
                STORAGE("e_points", "", 1);
                STORAGE("member_id", "", 1);
                STORAGE("logo_url", "", true);

                let delete_params = STORAGE("delete_params")
                  ? STORAGE("delete_params").split(",")
                  : [];
                for (var i = 0; i < delete_params.length; i++) {
                  STORAGE(delete_params[i], "", 1);
                }
                STORAGE("delete_params", "", 1);
                sessionStorage.removeItem("xoxoPointsState");
                sessionStorage.removeItem("xoxoCodeState");
                this.setState({ isLoading: false });
                window.location.href =
                  config.storeFrontURL + "marketplace/login";
              }.bind(this),
              {},
              "/logout"
            );
            return;
          }
          updateClientId(response.getClientId.data.client_id);
          updateKybStatus(response.getClientId.data);
          updateDistributionType(response.getClientId.data.distribution_type);
          updateCcRechargeAllowed(
            response.getClientId.data.cc_recharge_allowed
          );
          updateAllowOnlineTransfer(
            response.getClientId.data.allow_online_transfer
          );
          updateAllowedDomains(response.getClientId.data.allowed_domains);
        }
        this.props.updateShowCts(response.getClientId.showCts || false);
        this.setState({ loader: false });
      })
      .catch(() => {
        this.setState({ loader: false });
        NotificationManager.error("Unable to fetch Client Id details", "Error");
      });
  };

  fetchMFADetails = async () => {
    this.setState({ loader: true });
    const MFAData = await ProfileService.fetchMFAData();
    const { updateMFAData } = this.props;
    updateMFAData({ res: MFAData?.fetchMFADetails?.res || [] });
    this.setState({ loader: false });
  };

  // getMenuforAwardAccess = () => {
  //   this.setState({ loader: true });
  //   const { checkForAwardMenu } = this.props;

  //   ProfileService.getMenuforAwardAccess({}).then((response) => {
  //     checkForAwardMenu(response);
  //     this.setState({ loader: false });
  //   });
  // };
  getSupport = () => {
    let subNavList = [
      {
        name: "Support",
        link: `https://xoxoday.gitbook.io/plum/for-admins-1/getting-started`,
        icon: "/admin/img/icons/icon-manage-integrations-logo.svg",
        moduleId: "manage_integrations",
        integrations: 1,
      },
    ];
  };
  getAllIntegrations = () => {
    this.setState({ loader: true });
    const { checkForAllIntegrations } = this.props;
    profileService.getAllIntegration({}).then((response) => {
      let subNavList = [
        {
          name: "Integration",
          link: `/${app_path}/integration-dashboard/manage-integration`,
          icon: "/admin/img/icons/icon-manage-integrations-logo.svg",
          moduleId: "manage_integrations",
          integrations: 1,
        },
      ];
      if (response.length > 0) {
        response.map((item) => {
          let dict = {
            name: item.name,
            link: `/${app_path}/integrations/dashboard/` + item.code,
            icon: item.app_image,
            moduleId: item.code,
            integrations: "1",
          };
          subNavList.push(dict);
        });
      } else {
        /* empty */
      }
      // let navListObj = {
      // 		name 	: 	'Integrations',
      // 		link 	: 	'/admin/integration-dashboard/',
      // 		icon: IconIntegration,
      // 		moduleId : ACL_MODULE_MAPPING.COMMON,
      // 		subModules : subNavList
      // }
      // navList.push(navListObj)
      checkForAllIntegrations(subNavList);
      this.setState({ loader: false });
    });
  };
  getActiveIntegration = () => {
    this.setState({ loader: true });
    const { checkForActiveIntegration } = this.props;
    profileService.getMenuforActiveIntegration({}).then((response) => {
      checkForActiveIntegration(response);
      this.setState({ loader: false });
    });
  };
  getAddressDetails = () => {
    this.setState({ getAddressDetailsLoader: true });
    const { updateCompanyDetails } = this.props;

    ProfileService.addressDetails({})
      .then((response) => {
        if (
          response &&
          response.fetchCompanyDetails &&
          response.fetchCompanyDetails.company_details &&
          response.fetchCompanyDetails.company_details[0]
        ) {
          // let data = response.fetchCompanyDetails.company_details[0];
          updateCompanyDetails(response.fetchCompanyDetails.company_details[0]);
          // this.props.updateState({company_details:data})
          // this.stateList(data.company_country_id);
          // this.cityList(data.company_state_id);
        }
        this.setState({ getAddressDetailsLoader: false });
      })
      .catch(() => {
        this.setState({ getAddressDetailsLoader: false });
      });
  };

  plumProPoints = () => {
    this.setState({ loader: true });
    const { updatePlumProPoints } = this.props;

    ProfileService.plumProPoints({})
      .then((response) => {
        if (
          response &&
          response.cashReserveBalance &&
          response.cashReserveBalance.status == true
        ) {
          let data = response.cashReserveBalance.data.balance;

          this.setState({
            // cashBalance : data.balance,
            // currencySymbol: data.currencySymbol,
            // currencyId: data.currencyId,
            // currencyValue:data.currencyValue,
            loader: false,
          });
          updatePlumProPoints(data);
        }
      })
      .catch(() => {
        NotificationManager.error("Unable to fetch balance details", "Error");
        this.setState({
          cashBalance: 0,
          currencySymbol: "₹",
          error: "Unable to fetch balance details",
          loader: false,
        });
      });
  };

  getUserBalance = () => {
    this.setState({ loader: true });
    const { updateUserBalance } = this.props;

    ProfileService.userBalance({})
      .then((response) => {
        if (
          response &&
          response.getVoucherBalance &&
          response.getVoucherBalance.error == false
        ) {
          let data = {
            currencySymbol:
              response.getVoucherBalance.data.formatted["currencySymbol"],
            userBalance: response.getVoucherBalance.data.formatted["balance"],
            companyBalance:
              response.getVoucherBalance.data.formatted["companyBalance"],
            currencyValue:
              response.getVoucherBalance.data.formatted["currencyValue"],
            currencyCode:
              response.getVoucherBalance.data.formatted["currencyCode"],
          };
          this.setState({
            loader: false,
          });
          updateUserBalance(data);
        }
      })
      .catch(() => {
        NotificationManager.error("Unable to fetch balance details", "Error");
        this.setState({
          cashBalance: 0,
          currencySymbol: "₹",
          error: "Unable to fetch balance details",
          loader: false,
        });
      });
  };

  setDefaultSite() {
    try {
      const query = "storesAdmin.query.setDefault_Site";
      const post_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(
        post_data,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.setDefaultSite &&
            response.data.setDefaultSite.error == false
          ) {
            /* empty */
          }
          const { employeeDetails: { domain = "" } = {} } =
            this.props.accountReducer;
          if (!domain) {
            this.fetchAdminDetails();
          }
        }.bind(this)
      );
    } catch (e) {
      /* empty */
    }
  }

  getMenu = () => {
    this.setState({ getMenuLoader: true });
    ProfileService.getMenu()
      .then((response) => {
        this.setState({ getMenuLoader: false });
        if (response && response.success === 1) {
          let data = response.data || {};

          if (data.threshold_amount) {
            data.threshold_amount =
              Math.round(data.threshold_amount * 100) / 100;
          }
          if (data.admin_balance) {
            data.admin_balance = Math.round(data.admin_balance * 100) / 100;
          }
          this.props.updateUserAndCompanyType(data);
        } else {
          window.location.href = config.storeFrontURL;
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        this.getUserModuleAccess();
      });
  };

  getUserModuleAccess = () => {
    const { accountReducer: { typeData: { walletCompany = 0 } = {} } = {} } =
      this.props;
    this.setState({ moduleAclLoader: true });
    ProfileService.getUserModuleAccess().then((response) => {
      this.setState({ moduleAclLoader: false });
      if (response && Array.isArray(response) && response.length) {
        response.push({ module_id: 0, name: "Common" });
      }
      if (!walletCompany) {
        //removed xoxo link for non wallet company
        response = response.filter((item) => item.module_id != 12);
      }
      const moduleAcl = response?.map((item) => item.module_id);
      //isFirstRewardSent shall never be true for integration case, therefore explicitly setting
      this.setState({
        isFirstRewardSent:
          moduleAcl.includes(ACL_MODULE_MAPPING.STOREFRONT_INTEGRATION) ||
          moduleAcl.includes(ACL_MODULE_MAPPING.DARWINBOX_INTEGRATION) ||
          moduleAcl.includes(ACL_MODULE_MAPPING.SAP_INTEGRATION)
            ? true
            : this.state.isFirstRewardSent,
      });
      this.props.updateModuleAccessList(response);
    });
  };

  getDatalayerData = async () => {
    let hasLinkCampaign = false;
    const {
      accountReducer: {
        companyDetails: { company_name = "", usecase_id = 0 } = {},
        moduleAcl = [],
        typeData: { walletCompany = 1, role = 100 } = {},
        userBalance: {
          currencyCode = "INR",
          userBalance = 0,
          companyBalance = 0,
        } = {},
        kybStatus: { kyb_status = 0 } = {},
        activeIntegration = [],
        employeeDetails: {
          employee_first_name = "",
          employee_last_name = "",
          employee_email = "",
          user_creation_date = "",
        } = {},
        clientId = 0,
        platformSettings: { lowBalanceThreshold = 0 } = {},
      } = {},
    } = this.props;
    const { use_case } = this.state;
    let walletThree = 1;
    if (walletCompany === 1) {
      walletThree = 0;
    }

    const user_identity_data = {
      email: employee_email,
      client_id: clientId,
      full_name: employee_first_name + " " + employee_last_name,
      account_name: company_name,
      user_creation_date: user_creation_date,
      user_role: role,
    };

    posthog.identify(employee_email, user_identity_data);

    const moduleAclArray = moduleAcl.map((item) => item.module_id) || [];

    if (
      MODULE_ACL_SWITCH == false ||
      moduleAclArray.includes(ACL_MODULE_MAPPING.EMPULS)
    ) {
      empulsPaymentHistory(role).then((res) => {
        if (Object.keys(res).length > 0) {
          window.dataLayer.push({
            account_first_recharge_done: true,
            user_recharged_wallet: true,
            account_wallet_recharge_value: parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: true,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: true,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
          });
          update({
            "Recharge Value": parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
            "Recharge Done": false,
          });
        } else {
          window.dataLayer.push({
            account_first_recharge_done: false,
            user_recharged_wallet: false,
            account_wallet_recharge_value: 0,
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: false,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: false,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: 0,
          });
          update({
            "Recharge Value": 0,
            "Recharge Done": false,
          });
        }
      });
    }
    if (
      (MODULE_ACL_SWITCH == false ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)) &&
      walletThree
    ) {
      plumProPaymentHistory().then((res) => {
        if (Object.keys(res).length > 0) {
          window.dataLayer.push({
            account_first_recharge_done: true,
            user_recharged_wallet: true,
            account_wallet_recharge_value: parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: true,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: true,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
          });
          update({
            "Recharge Value": parseFloat(
              res.total.replace(res.symbol_left, "")
            ),
            "Recharge Done": true,
          });
        } else {
          window.dataLayer.push({
            account_first_recharge_done: false,
            user_recharged_wallet: false,
            account_wallet_recharge_value: 0,
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: false,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: false,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: 0,
          });
          update({
            "Recharge Value": 0,
            "Recharge Done": false,
          });
        }
      });
    }
    if (walletThree) {
      voucherRechargeHistory().then((res) => {
        if (Object.keys(res).length > 0) {
          window.dataLayer.push({
            account_first_recharge_done: true,
            user_recharged_wallet: true,
            account_wallet_recharge_value: parseFloat(res.amount),
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: true,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: true,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: parseFloat(res.amount),
          });
          update({
            "Recharge Value": parseFloat(res.amount),
            "Recharge Done": false,
          });
        } else {
          window.dataLayer.push({
            account_first_recharge_done: false,
            user_recharged_wallet: false,
            account_wallet_recharge_value: 0,
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: false,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: false,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: 0,
          });
          update({
            "Recharge Value": 0,
            "Recharge Done": false,
          });
        }
      });
    } else if (walletThree === 0) {
      plumPaymentHistoryReq().then((res) => {
        if (Object.keys(res).length > 0) {
          window.dataLayer.push({
            account_first_recharge_done: true,
            user_recharged_wallet: true,
            account_wallet_recharge_value: parseFloat(res.amount),
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: true,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: true,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: parseFloat(res.amount),
          });
          update({
            "Recharge Value": parseFloat(res.amount),
            "Recharge Done": false,
          });
        } else {
          window.dataLayer.push({
            account_first_recharge_done: false,
            user_recharged_wallet: false,
            account_wallet_recharge_value: 0,
          });
          posthog.capture("account_first_recharge_done", {
            account_first_recharge_done: false,
          });
          posthog.capture("user_recharged_wallet", {
            user_recharged_wallet: false,
          });
          posthog.capture("account_wallet_recharge_value", {
            account_wallet_recharge_value: 0,
          });
          update({
            "Recharge Value": 0,
            "Recharge Done": false,
          });
        }
      });
    }

    const isXoxoLinkEnabled = moduleAcl
      .map((item) => item.module_id)
      .includes(ACL_MODULE_MAPPING.XOXO_LINK);
    const isXoxoCodeEnabled = moduleAcl
      .map((item) => item.module_id)
      .includes(ACL_MODULE_MAPPING.XOXO_VOUCHER);
    const isXoxoPointEnabled = moduleAcl
      .map((item) => item.module_id)
      .includes(ACL_MODULE_MAPPING.XOXO_POINT);
    const isRewardsEnabled = moduleAcl
      .map((item) => item.module_id)
      .includes(ACL_MODULE_MAPPING.PLUM_PRO);

    if (isXoxoLinkEnabled) {
      await ProfileService.fetchOneClickCampaignSites({
        offset: 0,
        limit: 1,
        name: "",
      }).then((oneClickSiteList) => {
        if (
          oneClickSiteList.hasOwnProperty("success") &&
          oneClickSiteList.success
        ) {
          hasLinkCampaign = oneClickSiteList.count > 0;
        }
      });
    }

    let userKybStatus = "pending";
    switch (kyb_status) {
      case 0:
        userKybStatus = "pending";
        break;
      case 1:
        userKybStatus = "submitted";
        break;
      case 2:
        userKybStatus = "approved";
        break;
      case 3:
        userKybStatus = "resubmission";
        break;
      case 4:
        userKybStatus = "rejected";
        break;
      default:
        break;
    }
    const json = {
      account_name: company_name,
      account_company_type:
        walletCompany === 1 ? "common wallet" : "individual wallet",
      account_base_currency: currencyCode,
      account_kyb_status: userKybStatus,
      client_id: clientId,
      first_name: employee_first_name,
      last_name: employee_last_name,
      full_name: employee_first_name + " " + employee_last_name,
      email: employee_email,
      has_integration: activeIntegration.length > 0,
      number_of_connectors_used: activeIntegration.length,
      has_xoxolink_campaign: hasLinkCampaign,
      has_xoxocode_enabled: isXoxoCodeEnabled,
      has_xoxopoints_enabled: isXoxoPointEnabled,
      has_rewardsapi: isRewardsEnabled,
      has_rewards_dashboard_enabled: use_case?.toLowerCase() === "plum pro",
      low_balance: (userBalance || companyBalance) <= lowBalanceThreshold,
      // account_usage_type: "test",
    };
    update({
      "Company Name": company_name,
      "Client Id": clientId,
      "Base Currency": currencyCode,
      "Xoxocode Module Enabled": isXoxoCodeEnabled,
      "Number of Connectors Used": activeIntegration.length,
      "KYB Status": userKybStatus,
      "Has XoxoPoints Enabled": isXoxoPointEnabled,
      "Has Xoxolink Campaign": hasLinkCampaign,
      "Has Integration": activeIntegration.length > 0,
      "Has Rewards API": isRewardsEnabled,
    });
    window.dataLayer.push(json);

    posthog.capture("account_name", {
      account_name: company_name,
    });
    posthog.capture("account_company_type", {
      account_company_type:
        walletCompany === 1 ? "common wallet" : "individual wallet",
    });
    posthog.capture("account_base_currency", {
      account_base_currency: currencyCode,
    });
    posthog.capture("account_kyb_status", {
      account_kyb_status: userKybStatus,
    });
    posthog.capture("client_id", {
      client_id: clientId,
    });
    posthog.capture("first_name", {
      first_name: employee_first_name,
    });
    posthog.capture("last_name", {
      last_name: employee_last_name,
    });
    posthog.capture("full_name", {
      full_name: employee_first_name + " " + employee_last_name,
    });
    posthog.capture("email", {
      email: employee_email,
    });
    posthog.capture("has_integration", {
      has_integration: activeIntegration.length > 0,
    });
    posthog.capture("number_of_connectors_used", {
      number_of_connectors_used: activeIntegration.length,
    });
    posthog.capture("has_xoxolink_campaign", {
      has_xoxolink_campaign: hasLinkCampaign,
    });
    posthog.capture("has_xoxocode_enabled", {
      has_xoxocode_enabled: isXoxoCodeEnabled,
    });
    posthog.capture("has_xoxopoints_enabled", {
      has_xoxopoints_enabled: isXoxoPointEnabled,
    });
    posthog.capture("has_rewardsapi", {
      has_rewardsapi: isRewardsEnabled,
    });
    posthog.capture("has_rewards_dashboard_enabled", {
      has_rewards_dashboard_enabled: use_case?.toLowerCase() === "plum pro",
    });
    posthog.capture("low_balance", {
      low_balance: (userBalance || companyBalance) <= lowBalanceThreshold,
    });
  };

  componentDidUpdate() {
    if (this.state.progress >= 90) {
      clearInterval(this.timer);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  doLoginCheck = () => {
    //check if a user is loggen in or not

    //login
    let token = getCookieToken(LOGIN_COOKIE_NAME);
    if (Number(token) === 1) {
      this.setState({
        module_acl_switch: true,
      });
    } else {
      this.setState({
        module_acl_switch: false,
      });
    }
    return token;
  };

  generatePrivateRoutes = () => {
    return Object.keys(route.routes).map((key, idx) => {
      let routeParams = route.routes[key];
      return (
        <PrivateRoute
          key={idx}
          component={routeParams.component}
          path={routeParams.path}
          authenticated={true}
          {...this.props}
        />
      );
    });
  };

  getPlatformSetting = () => {
    this.setState({ loader: true });
    let fetchData = {
      urlPrefix: "",
    };
    ProfileService.getPlatformSetting(fetchData)
      .then((response) => {
        let res = (response && response.fetchPlatformSetting) || {};
        if (res.success == 1 && res.data) {
          this.props.updatePlatformSettings(res.data);
        }
        this.setState({ loader: false });
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.log("error", error);
      });
  };

  renderRoutes() {
    const { match = this.props.location.pathname } = this.props;
    const pathname = this.props.location.pathname;
    const adminPrefix = `/${app_path}/`;
    let {
      accountReducer: { companyDetails = {}, employeeDetails = {} } = {},
      bulkProcessReducer,
    } = this.props;
    const { module_acl_switch = false, isMobileDevice = false } = this.state;

    const showNotificationBar =
      bulkProcessReducer &&
      bulkProcessReducer.bulkProcessData &&
      bulkProcessReducer.bulkProcessData.length > 0
        ? true
        : false;
    return isMobileDevice ? (
      <MobileLanding />
    ) : (
      <React.Fragment>
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path={adminPrefix + "signup"}
              render={(props) => <SignUp {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "payment/"}
              render={(props) => <VoucherPayment {...this.props} />}
            />

            <Route
              exact
              path={adminPrefix + "recharge-callback"}
              render={(props) => <PaymentCallback {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "paypal-recharge-callback/:id"}
              render={(props) => <PaypalPaymentCallback {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "recharge-callback-res-fund"}
              render={(props) => <PaymentCallbackReserveFund {...this.props} />}
            />
            <Route
              path={adminPrefix + "payment-status/:id/:key"}
              render={(props) => <PaymentStatus {...this.props} />}
            />
            <Route
              path={adminPrefix + "paypal-payment-status/:id/:key"}
              render={(props) => <PaypalPaymentStatus {...this.props} />}
            />
            <Route
              path={adminPrefix + "razorpay-payment-status/:id/:key"}
              render={(props) => <RazorpayPaymentStatus {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "razorpay-recharge-callback/:id"}
              render={(props) => <RazorpayPaymentCallback {...this.props} />}
            />
            <Route
              path={adminPrefix + "stripe-payment-status/:id/:key"}
              render={(props) => <StripePaymentStatus {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "primer-recharge-callback/:id"}
              render={(props) => <PrimerPaymentCallback {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "stripe-recharge-callback"}
              render={(props) => <StripePaymentCallback {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "payoneer-payment-callback/"}
              render={(props) => <PayoneerPaymentCallback {...this.props} />}
            />
            <Route
              path={adminPrefix + "payoneer-payment-status/:id/"}
              render={(props) => <PayoneerPaymentStatus {...this.props} />}
            />
            <Route
              exact
              path={adminPrefix + "payment/paypal"}
              render={(props) => <PaypalPayment {...this.props} />}
            />
            {/* <Route
              exact
              path={"/admin/integrations/automation/:id"}
              render={(props) => <SurveyMonkey {...this.props} />}
            />
           */}

            <Route
              exact
              path={adminPrefix + "select-survey/"}
              render={(props) => <SelectSurvey {...this.props} />}
            />
            <Route
              exact={true}
              path={adminPrefix + "xoxo-voucher/email-preview-screen/"}
              render={(props) => <EmailPreviewScreen {...this.props} />}
            />
            <Route
              exact={true}
              path={adminPrefix + "xoxo-link/email-preview-screen/"}
              render={(props) => <XoxolinkEmailPreview {...this.props} />}
            />

            <Route
              exact
              path={adminPrefix + "campaigns/landing/preview/"}
              render={(props) => <CampaignLandingPreview {...this.props} />}
            />

            <div className="CreateXoxoVoucher">
              <div className="createVoucherContainer">
                <div className={"contentWrapperSection container-fluid"}>
                  {/* {this.generatePrivateRoutes()}  */}
                  {module_acl_switch === true ? (
                    <>
                      {/* <HeaderOld
                        companyDetails={companyDetails}
                        employeeDetails={employeeDetails}
                        showNotificationBar={showNotificationBar}
                        {...this.props}
                      /> */}
                      <Header
                        companyDetails={companyDetails}
                        employeeDetails={employeeDetails}
                        showNotificationBar={showNotificationBar}
                        isFirstRewardSent={this.state.isFirstRewardSent}
                        {...this.props}
                        privateRoutes={() => (
                          <PrivateRoutes
                            pathname={pathname}
                            adminPrefix={adminPrefix}
                            match={match}
                            {...this.state}
                            {...this.props}
                            fetchAdminDetails={this.fetchAdminDetails}
                          />
                        )}
                        mfaData={this.props.accountReducer.mfaData}
                        updateMFAData={this.props.updateMFAData}
                      />
                      {/* <Sidebar
                        pathname={pathname}
                        adminPrefix={adminPrefix}
                        match={match}
                        {...this.props}
                      /> */}
                    </>
                  ) : (
                    <AccessDenied />
                  )}

                  <NotificationContainer />
                </div>
              </div>
              <Footer />
            </div>
          </Switch>
        </BrowserRouter>
      </React.Fragment>
    );
  }

  render() {
    const {
      getMenuLoader,
      loader,
      moduleAclLoader,
      showPageLoader,
      dasboard_load,
      fetchAdminDetailsLoader,
    } = this.state;

    if (showPageLoader) {
      return <PageLoader value={this.state.progress} />;
    }
    return (
      <ErrorBoundary FallbackComponent={ExceptionHandler}>
        {getMenuLoader === false &&
        loader === false &&
        dasboard_load === false &&
        moduleAclLoader === false &&
        fetchAdminDetailsLoader === false ? (
          this.renderRoutes()
        ) : (
          <PageLoader value={this.state.progress} />
        )}
      </ErrorBoundary>
    );
  }
}

export default withRouter(Index);
